import { formatDeleteDocumentParams, }              from 'dmpconnectjsapp-base/actions/config/commandParamsFormatters';
import commands                                     from 'dmpconnectjsapp-base/actions/config/commands';
import { apiSections }                              from 'dmpconnectjsapp-base/constants';
import { getApiType, getHealthcareSetting }         from 'dmpconnectjsapp-base/helpers/accessors';
import moment                                       from 'moment';
import PropTypes                                    from 'prop-types';
import React                                        from 'react';
import { Dropdown }                                 from 'react-bootstrap';
import { connect }                                  from 'react-redux';
import { getAction, showUploadDocumentModal, }      from '../../dmpconnect/actions';
import { documentFormats }                          from '../../dmpconnect/constants';
import { closeConfirmModal, confirmDeleteDocument } from '../../dmpconnect/helpers/documentUtils';
import { getUniqueUUid, }                           from '../../dmpconnect/rules/documentRules';

// eslint-disable-next-line react/prop-types
const DropdownToggle = React.forwardRef(({ onClick }, ref) => (
  <button
    type="button"
    className="btn btn-sm btn-borderless-secondary btn-icon-only mr-0"
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    <i className="ic-navigation-menu-vertical"/>
  </button>
));

const ImmunizationNoteDropdownActions = ({
  dispatch,
  document,
  ins,
  healthcareSetting,
  submitEngine,
  canModify,
  canDelete,
  shouldValidate,
  lastOne,
  hvUniqueId
}) => {
  
  const deleteDocument = () => {
    const { s_uniqueId: uniqueId, s_uuid: uuid } = document;
    
    closeConfirmModal(dispatch);
    
    dispatch(getAction(
      commands.deleteArchivedDocument,
      apiSections.DELETE_ARCHIVED_DOCUMENT_SECTION,
      formatDeleteDocumentParams(uniqueId, uuid, ins, healthcareSetting, submitEngine),
      {
        subSection: getUniqueUUid(uniqueId, uuid),
        contextExtra: {
          lastOne,
          hvUniqueId,
        }
      },
    ));
  };
  
  if (!canModify && !canDelete && !shouldValidate) {
    return <></>;
  }
  
  return (
    <>
      <Dropdown className="no-arrow">
        <Dropdown.Toggle as={DropdownToggle} id={`dropdown-document-${document.s_uniqueId}-actions`}/>
        <Dropdown.Menu className="super-colors">
          {canModify && (
            <div className="d-inline-block">
              <Dropdown.Item
                onClick={() => dispatch(showUploadDocumentModal(true, ins, document))}
              >
                <i className="ic-edit mr-2"/>
                Modifier
              </Dropdown.Item>
            </div>
          )}
          
          {canDelete && (
            <div className="d-inline-block">
              <Dropdown.Item
                onClick={() => confirmDeleteDocument(dispatch, ins, document, deleteDocument, false)}
              >
                <i className="ic-delete mr-2 text-danger"/>
                Supprimer
              </Dropdown.Item>
            </div>
          )}
          
          
          {shouldValidate && (
            <div className="d-inline-block">
              <Dropdown.Item
                onClick={() => dispatch(showUploadDocumentModal(
                  true,
                  ins,
                  {
                    StructuredBody: {
                      Sections: [{
                        'i_type'     : 30,
                        Immunizations: [{
                          ...document,
                        }]
                      }]
                    },
                    s_title: 'Note de vaccination',
                    s_typeCode: '87273-9',
                    s_creationDate: moment().format('YYYYMMDDHHmmss'),
                    s_serviceStartDate: moment(document.s_date, 'YYYYMMDDHHmmssZZ').format('YYYYMMDDHHmmss'),
                    s_serviceStopDate: moment(document.s_date, 'YYYYMMDDHHmmssZZ').format('YYYYMMDDHHmmss'),
                    i_document_Format: documentFormats.vacNote,
                    vacNoteToValidate: true,
                  }
                ))}
              >
                <i className="ic-validate mr-2 text-success"/>
                Valider
              </Dropdown.Item>
            </div>
          )}
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

ImmunizationNoteDropdownActions.defaultProps = {
  accessRights     : {},
  healthcareSetting: '',
  submitEngine     : undefined,
  canModify        : false,
  canDelete        : false,
  shouldValidate   : false,
  lastOne   : false
};

ImmunizationNoteDropdownActions.propTypes = {
  dispatch         : PropTypes.func.isRequired,
  document         : PropTypes.object.isRequired,
  accessRights     : PropTypes.object,
  ins              : PropTypes.string.isRequired,
  healthcareSetting: PropTypes.string,
  apiType          : PropTypes.string.isRequired,
  submitEngine     : PropTypes.string,
  canModify        : PropTypes.bool,
  canDelete        : PropTypes.bool,
  shouldValidate   : PropTypes.bool,
  lastOne   : PropTypes.bool,
  hvUniqueId   : PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const
    {
      dmpconnectApplication: {
        submitEngine,
      },
    } = state;
  
  return {
    apiType          : getApiType(state),
    healthcareSetting: getHealthcareSetting(state),
    submitEngine,
  };
}

export default connect(mapStateToProps)(ImmunizationNoteDropdownActions);
